export default __webpack_public_path__ + "static/couples-therapy-header-719c38e51ed6e10519901f4cc730d51a.webp";